/**
 * The query as it is right now: `useSearchParams` reports the last router
 * navigation, so it omits anything since written with `history.replaceState`.
 */
export const liveSearchParams = () => new URLSearchParams(window.location.search)
